module.exports = __webpack_public_path__ + "media/SetB_L2_C.500fc693.mp3";